/**
 * External dependencies
 */

import React from 'react';
import classNames from 'classnames';
import './styles.scss';
import { Box } from '@towersystems/towersystems-design-system';

const Main = ({ className, children, ...rest }) => {
	const classes = classNames(className, 'main');
	return (
		<Box component='main' className={classes} role='main' {...rest}>
			{children}
		</Box>
	);
};

Main.defaultProps = {
	paddingLeft: 'xxlarge',
	paddingRight: 'xxlarge',
    paddingTop: 'xxlarge',
    paddingBottom: 'xxlarge'
};

export default Main;
